// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import * as Sentry from '@sentry/nextjs';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

let firebaseApp: FirebaseApp | null = null;

// Check if running in a restricted browser before initialization
const isRestrictedBrowser = (): boolean => {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const restrictedBrowsers = [
    'FBAN',
    'FBAV',
    'Instagram',
    'FB_IAB',
    'FB4A',
    'FBIOS',
  ];

  return restrictedBrowsers.some((browser) =>
    ua.toUpperCase().includes(browser.toUpperCase())
  );
};

try {
  // Only initialize Firebase if not in a restricted browser
  if (!isRestrictedBrowser()) {
    firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();
  } else {
    console.warn(
      'Firebase initialization skipped: restricted browser detected'
    );
  }
} catch (e) {
  console.error('Failed to initialize Firebase:', e);

  // Log to Sentry but don't crash the app
  Sentry.captureException(e, {
    tags: {
      component: 'firebase-initialization',
      userAgent:
        typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
    },
    level: 'warning',
  });
}

export default firebaseApp;
